import './LoadingSpinner.css'

function LoadingSpinner({ size = 'medium' }) {
  return (
    <div className={`spinner ${size}`}>
      <div className="spinner-circle"></div>
    </div>
  )
}

export default LoadingSpinner
